import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import Logo from '../common/Logo.jsx';

export default function DashboardHeader({ title, onMenuClick }) {
  const { user, logout } = useAuth();
  return (
    <header className="flex flex-wrap items-center justify-between gap-3 border-b bg-white px-3 py-3 sm:px-6">
      <div className="flex min-w-0 items-center gap-2 sm:gap-3">
        {onMenuClick && (
          <button
            type="button"
            onClick={onMenuClick}
            aria-label="Open menu"
            className="rounded p-2 text-slate-600 hover:bg-slate-100 lg:hidden"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
              <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
            </svg>
          </button>
        )}
        <Link to="/" aria-label="ITEC Mobiles & Computers — Home" className="shrink-0">
          <Logo className="h-9 sm:h-11" />
        </Link>
        <span className="hidden text-slate-300 sm:inline">|</span>
        <span className="hidden truncate text-sm font-medium text-slate-700 sm:inline">
          {title}
        </span>
      </div>
      <div className="flex items-center gap-2 text-sm sm:gap-3">
        <span className="hidden truncate text-slate-500 sm:inline max-w-[12rem]">
          {user?.name}
        </span>
        <button
          onClick={logout}
          className="rounded border px-3 py-1.5 hover:bg-slate-50"
        >
          Logout
        </button>
      </div>
    </header>
  );
}
